<template>
  <Horizontal v-if="$auth.check()">
    <slot/>
  </Horizontal>
</template>

<script>
import Horizontal from "./horizontal";

export default {
  components: {
    Horizontal,
  }
};
</script>


